module.exports = {
  "reauthProcess": {
    "namespace": "reauth",
    "name": "ReAuth Authentication Step",
    "class": "usage",
    "properties": {
      "step": [
        "opened",
        "authenticated"
      ]
    }
  }
};